import { useState } from 'react'
import { uploadFile } from '@/shared/api'
import type { FileRef } from '@/shared/lib'
import { Button } from '@/shared/ui/button'
import { Dialog } from '@/shared/ui/dialog'
import { Field, Textarea } from '@/shared/ui/field'
import { FileDrop } from '@/shared/ui/file-drop'
import { FileRow } from '@/shared/ui/file-row'
import { toast } from '@/shared/ui/toast'
import { useAddVersion } from '../api/add-version'

interface AddVersionDialogProps {
  documentId: string
  open: boolean
  onClose: () => void
}

export function AddVersionDialog({ documentId, open, onClose }: AddVersionDialogProps) {
  const add = useAddVersion(documentId)
  const [file, setFile] = useState<FileRef | null>(null)
  const [note, setNote] = useState('')

  function submit() {
    if (!file) return
    add.mutate(
      { file, ...(note.trim() ? { note } : {}) },
      {
        onSuccess: () => {
          toast.success('Версия добавлена')
          onClose()
        },
        onError: () => toast.error('Не удалось добавить версию'),
      },
    )
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Новая версия"
      footer={
        <>
          <Button variant="ghost" onClick={onClose} disabled={add.isPending}>
            Отмена
          </Button>
          <Button onClick={submit} disabled={add.isPending || !file}>
            {add.isPending ? 'Добавляем…' : 'Добавить'}
          </Button>
        </>
      }
    >
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-2">
          <span className="label">Файл</span>
          {file ? (
            <FileRow file={file} onRemove={() => setFile(null)} />
          ) : (
            <FileDrop onUpload={uploadFile} onUploaded={setFile} />
          )}
        </div>
        <Field label="Заметка" hint="Что изменилось">
          {(props) => (
            <Textarea
              {...props}
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder="Учли правки заказчика"
            />
          )}
        </Field>
      </div>
    </Dialog>
  )
}
